import React, { useState } from 'react';
import './FilterUserModal.css';

interface SearchUserModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (userData: any) => void;
}

const FilterUserModal: React.FC<SearchUserModalProps> = ({ isVisible, onClose, onSearch }) => {
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const roles = ["Administrador del sistema", "ATC", "Técnico","Administrativo","Administrative"];
    const states = ["Activo", "Deshabilitado", "Bloqueado"];

    const handleSearchClick = async () => {
        const filters = {
            role: selectedRole,
            state: selectedState
        }
        onSearch(filters);
        onClose()
    };

    const handleClearFilters = () => {
        setSelectedRole('');
        setSelectedState('');
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">search</span>
                        <p className="buscar-header">FILTRAR</p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">close</span>
                    </div>
                </div>
                <div className="body-filter-user">
                    <div>
                        <select
                            id="role-dropdown"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                        >
                            <option value="">ROL</option>
                            {roles.map((role, index) => (
                                <option key={index} value={role}>
                                    {role}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <select
                            id="state-dropdown"
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                        >
                            <option value="">ESTADO</option>
                            {states.map((state, index) => (
                                <option key={index} value={state}>
                                    {state}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="filter-buttons">
                    <button onClick={handleSearchClick} className="filter-search-button">BUSCAR</button>
                    <button onClick={handleClearFilters} className="clear-button">
                        BORRAR FILTROS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterUserModal;